import {
  NOTIFICATION_DETAIL,
  NOTIFICATION_DETAIL_FAIL,
  NOTIFICATION_DETAIL_RESET,
  NOTIFICATION_DETAIL_SUCCESS,
  NOTIFICATION_HEADER_LIST,
  NOTIFICATION_HEADER_LIST_FAIL,
  NOTIFICATION_HEADER_LIST_RESET,
  NOTIFICATION_HEADER_LIST_SUCCESS,
  NOTIFICATION_LIST,
  NOTIFICATION_LIST_COLUMN,
  NOTIFICATION_LIST_FAIL,
  NOTIFICATION_LIST_RESET,
  NOTIFICATION_LIST_SUCCESS,
} from "./actionTypes";

// List Notification
export const listNotification = (params = {}) => ({
  type: NOTIFICATION_LIST,
  payload: { params },
});

export const listNotificationSuccess = data => ({
  type: NOTIFICATION_LIST_SUCCESS,
  payload: data,
});

export const listNotificationFail = error => ({
  type: NOTIFICATION_LIST_FAIL,
  payload: error,
});

export const resetListNotification = () => ({
  type: NOTIFICATION_LIST_RESET,
  payload: {},
});

export const setListNotificationColumn = (field, value) => ({
  type: NOTIFICATION_LIST_COLUMN,
  payload: { field, value },
});

// List Notification Header
export const listNotificationHeader = (params = {}) => ({
  type: NOTIFICATION_HEADER_LIST,
  payload: { params },
});

export const listNotificationHeaderSuccess = data => ({
  type: NOTIFICATION_HEADER_LIST_SUCCESS,
  payload: data,
});

export const listNotificationHeaderFail = error => ({
  type: NOTIFICATION_HEADER_LIST_FAIL,
  payload: error,
});

export const resetListNotificationHeader = () => ({
  type: NOTIFICATION_HEADER_LIST_RESET,
  payload: {},
});

// Detail Notification
export const detailNotification = (notificationId, params = {}) => ({
  type: NOTIFICATION_DETAIL,
  payload: { notificationId, params },
});

export const detailNotificationSuccess = data => ({
  type: NOTIFICATION_DETAIL_SUCCESS,
  payload: data,
});

export const detailNotificationFail = error => ({
  type: NOTIFICATION_DETAIL_FAIL,
  payload: error,
});

export const resetDetailNotification = () => ({
  type: NOTIFICATION_DETAIL_RESET,
  payload: {},
});
